/**
 * Method to be used for time server response parsing.
 */
export enum MKLiveSynchronizationMethod {
    /**
     * The time information is in the response HTTP 'Date' header.
     */
    HttpHead = "httphead",

    /**
     * The time information is in the response body a ISO 8601 timestamp.
     */
    HttpIso = "httpiso",

    /**
     * The time information is in the response body in xs:date format.
     */
    HttpXsDate = "httpxsdate"
}